import {Database} from '@tnc/shared';

import ApplicationItem from '@/pages/speculators/settings/components/ApplicationItem';
import ListingItem from '@/pages/speculators/settings/components/ListingItem';

type EntityType = 'retailer' | 'brand' | 'distributor';

type EntityBaseT = {
  [key: `${string}_id`]: number;
  [key: `${string}_name`]: string;
};

type ListingItemsPropsT<T extends EntityBaseT> = {
  items: T[] | undefined;
  entityType: EntityType;
  onRegisterClick: () => void;
  onLinkClick: () => void;
  applications?: Database['public']['Tables']['Applications']['Row'][];
};

function ListingItems<T extends EntityBaseT>({
  items,
  entityType,
  onRegisterClick,
  onLinkClick,
  applications = [],
}: ListingItemsPropsT<T>) {
  const getDescription = () => {
    switch (entityType) {
      case 'retailer':
        return 'Connect with premium tree suppliers and streamline your inventory management. Perfect for garden centers and retail locations looking to expand their offerings.';
      case 'brand':
        return 'Showcase your tree varieties and connect with qualified retailers. Ideal for growers and producers wanting to expand their market reach.';
      case 'distributor':
        return 'Bridge the gap between brands and retailers. Optimize your distribution network and manage your supply chain efficiently.';
      default:
        return '';
    }
  };

  return (
    <div>
      <p className="font-semibold capitalize text-neutral-700 underline underline-offset-2">Register a {entityType}</p>
      <p className="text-neutral-500">{getDescription()}</p>
      <div className="mt-4 flex items-center gap-2">
        <button className="ti-btn ti-btn-info-full capitalize" onClick={onLinkClick}>
          Link Existing {entityType}
        </button>
        <button className="ti-btn ti-btn-teal-full capitalize" onClick={onRegisterClick}>
          Register New {entityType}
        </button>
      </div>
      {applications.length > 0 && (
        <div>
          <div className="my-2 border-t border-slate-400/30"></div>
          <p className="font-semibold capitalize text-neutral-500">Your Pending Applications:</p>
          {applications.map(application => (
            <ApplicationItem key={application.application_id} application={application} entityType={entityType} />
          ))}
          <div className="my-2 border-t border-slate-400/30"></div>
        </div>
      )}
      {items && items.length > 0 && (
        <div>
          <div className="my-2 border-t border-slate-400/30"></div>
          <p className="font-semibold capitalize text-neutral-500">Your Registered {entityType}s:</p>
          {items.map(item => (
            <ListingItem key={item[`${entityType}_id`]} item={item} entityType={entityType} />
          ))}
          <div className="my-2 border-t border-slate-400/30"></div>
        </div>
      )}
    </div>
  );
}

export default ListingItems;
